(function () {
  var RESTORE_KEY = 'svPlpRestore';

  // Loads the next page's cards (via the Section Rendering API) about one screen before the
  // shopper reaches the end. The numbered pagination stays in the HTML for search engines.
  function initInfinite(root, grid, more) {
    var sectionId = root.getAttribute('data-section-id');
    var nextUrl = more.getAttribute('data-next-url');
    var status = more.querySelector('[data-sv-infinite-status]');
    var skeletons = more.querySelector('[data-sv-infinite-skeletons]');
    var retry = more.querySelector('[data-sv-infinite-retry]');
    var end = more.querySelector('[data-sv-infinite-end]');
    var loading = false;
    var loadedUrls = [];

    // Landing on ?page=3 from an old link keeps the page numbers so earlier pages stay reachable.
    if (more.getAttribute('data-current-page') === '1') root.classList.add('is-infinite');

    function sectionUrl(url) {
      var target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', sectionId);
      return target.toString();
    }

    function nearEnd() {
      return more.getBoundingClientRect().top < window.innerHeight * 2;
    }

    function loadNext() {
      if (loading || !nextUrl) return Promise.resolve(false);
      loading = true;
      retry.hidden = true;
      skeletons.hidden = false;
      var url = nextUrl;

      return fetch(sectionUrl(url), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-sv-plp-grid]');
          var newMore = doc.querySelector('[data-sv-infinite]');
          if (newGrid) {
            while (newGrid.firstElementChild) grid.appendChild(newGrid.firstElementChild);
          }
          loadedUrls.push(url);
          nextUrl = newMore ? newMore.getAttribute('data-next-url') : '';
          var newStatus = newMore && newMore.querySelector('[data-sv-infinite-status]');
          if (newStatus) status.textContent = newStatus.textContent;
          if (!nextUrl) {
            end.hidden = false;
            status.hidden = true;
          }
          return true;
        })
        .catch(function () {
          retry.hidden = false;
          return false;
        })
        .finally(function () {
          loading = false;
          skeletons.hidden = true;
        });
    }

    function loadWhileNearEnd() {
      if (!nextUrl || !nearEnd()) return;
      loadNext().then(function (ok) {
        if (ok) loadWhileNearEnd();
      });
    }

    // A scroll check rather than an observer also catches a fast fling that jumps past the loader.
    var scheduled = false;
    window.addEventListener(
      'scroll',
      function () {
        if (scheduled || !nextUrl) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          loadWhileNearEnd();
        });
      },
      { passive: true }
    );
    loadWhileNearEnd();

    retry.addEventListener('click', function () {
      loadNext().then(function (ok) {
        if (ok) loadWhileNearEnd();
      });
    });

    more.querySelector('[data-sv-back-to-top]').addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // Remember how far she scrolled so Back from a product returns to the same card.
    var pageKey = window.location.pathname + window.location.search;
    grid.addEventListener('click', function (event) {
      if (!event.target.closest('a[href]')) return;
      try {
        sessionStorage.setItem(
          RESTORE_KEY,
          JSON.stringify({ key: pageKey, urls: loadedUrls.slice(), y: window.scrollY })
        );
      } catch (e) {}
    });

    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      try {
        sessionStorage.removeItem(RESTORE_KEY);
      } catch (e) {}
    });

    var saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(RESTORE_KEY));
      sessionStorage.removeItem(RESTORE_KEY);
    } catch (e) {}
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var cameBack = nav && nav.type === 'back_forward';

    if (cameBack && saved && saved.key === pageKey && saved.urls && saved.urls.length) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      var restoreNext = function () {
        if (loadedUrls.length >= saved.urls.length || !nextUrl) {
          window.scrollTo(0, saved.y);
          return;
        }
        loadNext().then(function (ok) {
          if (ok) restoreNext();
          else window.scrollTo(0, saved.y);
        });
      };
      restoreNext();
    }
  }

  function initPlp(root) {
    if (!root || root.dataset.svPlpReady) return;
    root.dataset.svPlpReady = '1';

    var grid = root.querySelector('[data-sv-plp-grid]');
    var storageKey = 'sv-plp-layout';

    function setLayout(layout) {
      if (!grid) return;
      grid.setAttribute('data-layout', layout);
      try {
        localStorage.setItem(storageKey, layout);
      } catch (e) {}
      root.querySelectorAll('[data-sv-layout]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-sv-layout') === layout);
      });
    }

    try {
      var saved = localStorage.getItem(storageKey);
      if (saved) setLayout(saved);
    } catch (e) {}

    root.querySelectorAll('[data-sv-layout]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setLayout(btn.getAttribute('data-sv-layout'));
      });
    });

    /* Sort modal */
    var sortModal = root.querySelector('[data-sv-sort]');
    var sortOpen = root.querySelector('[data-sv-sort-open]');
    function openSort() {
      if (!sortModal) return;
      sortModal.hidden = false;
      document.documentElement.classList.add('sv-plp-modal-open');
    }
    function closeSort() {
      if (!sortModal) return;
      sortModal.hidden = true;
      document.documentElement.classList.remove('sv-plp-modal-open');
    }
    if (sortOpen) sortOpen.addEventListener('click', openSort);
    root.querySelectorAll('[data-sv-sort-close]').forEach(function (el) {
      el.addEventListener('click', closeSort);
    });

    /* Filter drawer */
    var filterDrawer = root.querySelector('[data-sv-filter]');
    var filterOpen = root.querySelector('[data-sv-filter-open]');
    function openFilter() {
      if (!filterDrawer) return;
      filterDrawer.hidden = false;
      document.documentElement.classList.add('sv-plp-modal-open');
    }
    function closeFilter() {
      if (!filterDrawer) return;
      filterDrawer.hidden = true;
      document.documentElement.classList.remove('sv-plp-modal-open');
    }
    if (filterOpen) filterOpen.addEventListener('click', openFilter);
    root.querySelectorAll('[data-sv-filter-close]').forEach(function (el) {
      el.addEventListener('click', closeFilter);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSort();
        closeFilter();
      }
    });

    var more = root.querySelector('[data-sv-infinite]');
    if (more && grid && window.fetch && window.DOMParser) initInfinite(root, grid, more);
  }

  function initAll() {
    document.querySelectorAll('[data-sv-plp]').forEach(initPlp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
